import { useState } from 'react';
import axios from 'axios';
import { API } from '../../config/api';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Mail } from 'lucide-react';

export function SubscribeSection({ siteSettings, isVisible }) {
  const [fanEmail, setFanEmail] = useState('');
  const [fanName, setFanName] = useState('');
  const [subscribing, setSubscribing] = useState(false);
  const [subscribed, setSubscribed] = useState(false);

  if (!isVisible('subscribe')) return null;

  const handleFanSubscribe = async (e) => {
    e.preventDefault();
    if (!fanEmail.trim()) return;
    setSubscribing(true);
    try {
      await axios.post(`${API}/fan-subscribe`, { email: fanEmail, name: fanName });
      setSubscribed(true);
      setFanEmail('');
      setFanName('');
    } catch {
      // silently fail
    }
    setSubscribing(false);
  };

  return (
    <section className="border-t border-[#262626] py-16 sm:py-24 px-4 sm:px-8" data-testid="subscribe-section">
      <div className="max-w-2xl mx-auto text-center">
        <p className="overline text-[var(--primary,#FF3B30)] mb-4">{siteSettings?.section_titles?.subscribe_label || 'STAY UPDATED'}</p>
        <h2 className="font-cabinet text-3xl sm:text-4xl font-black uppercase tracking-tighter mb-4">
          {siteSettings?.section_titles?.subscribe || 'JOIN THE LIST'}
        </h2>
        <p className="text-[#A3A3A3] mb-8">
          Get notified when new music drops & when items go on sale.
        </p>

        {subscribed ? (
          <div className="bg-[#141414] border border-[#22C55E]/30 p-6" data-testid="subscribed-success">
            <p className="text-[#22C55E] font-bold uppercase tracking-wider mb-1">You're in!</p>
            <p className="text-[#A3A3A3] text-sm">You'll be the first to know about new drops & sales.</p>
          </div>
        ) : (
          <form onSubmit={handleFanSubscribe} className="space-y-4 max-w-md mx-auto">
            <div className="relative">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#A3A3A3]" />
              <Input
                type="email"
                placeholder="your@email.com"
                value={fanEmail}
                onChange={(e) => setFanEmail(e.target.value)}
                required
                className="pl-10 bg-[#141414] border-[#262626] focus:border-[var(--primary,#FF3B30)] rounded-none h-12 text-white"
                data-testid="fan-subscribe-email"
              />
            </div>
            <Input
              type="text"
              placeholder="Your name (optional)"
              value={fanName}
              onChange={(e) => setFanName(e.target.value)}
              className="bg-[#141414] border-[#262626] focus:border-[var(--primary,#FF3B30)] rounded-none h-12 text-white"
              data-testid="fan-subscribe-name"
            />
            <Button
              type="submit"
              disabled={subscribing}
              className="w-full bg-[var(--primary,#FF3B30)] hover:bg-white hover:text-[#0A0A0A] rounded-none h-12 px-8 font-bold uppercase tracking-wider"
              data-testid="fan-subscribe-btn"
            >
              {subscribing ? 'SUBSCRIBING...' : 'SUBSCRIBE'}
            </Button>
          </form>
        )}
      </div>
    </section>
  );
}
